import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import Options from "./components/Options";
import {
    getResultFromVoteList,
    StuVoteItem,
    VoteContent,
    VoteTypeMap
} from "service/vote";
import Header from "./components/Header";
import InputSearch from "components/CourseComponents/InputSearch";
import StuListSimple from "components/CourseComponents/StuListSimple";

interface VoteScreenProps {
    data: VoteContent;
    stuList: StuVoteItem[];
    onChange: () => void;
    onCountDown: () => void;
}

export default function VoteScreen({
    data,
    stuList,
    onChange,
    onCountDown
}: VoteScreenProps) {
    const [status, setStatus] = useState("all");
    const [searchText, setSearchText] = useState("");

    // 投票结果
    const voteResult = useMemo(() => {
        if (!stuList || !data) return [];
        return getResultFromVoteList(data.type, data.answersNumber, stuList);
    }, [stuList, data]);

    // 筛选的列表
    const filteredList = useMemo(() => {
        return stuList
            .filter(
                item =>
                    item.name.indexOf(searchText) !== -1 ||
                    item.studentNo === searchText
            )
            .filter(item => {
                // 投票状态
                if (status === "all") return true;
                if (status === "vote" && item.voteStatus === "1") return true;
                return status === "unVote" && item.voteStatus === "0";
            });
    }, [searchText, status, stuList]);

    function renderStatus({ status }: any) {
        if (status === "0") return "--";
        return <span className={style.status}>已投票</span>;
    }

    return (
        <div className={style.root}>
            <div className={style.left}>
                <div className={style.header}>
                    <h1 className={style.title}>投票活动</h1>
                    <p className={style.tip}>
                        【{VoteTypeMap[data.type]}题】
                        请根据老师口述的题目或观点，进行投票。
                    </p>
                </div>

                <div className={style.main}>
                    <Options total={stuList?.length || 1} data={voteResult} />
                </div>
            </div>

            <div className={style.right}>
                <Header
                    data={data}
                    stuList={stuList}
                    filterStatus={status}
                    onFilterStatusChange={setStatus}
                    onChange={onChange}
                    onCountDown={onCountDown}
                />
                <InputSearch
                    onChange={setSearchText}
                    placeholder="输入姓名、学号查看学生的投票状态"
                />
                <StuListSimple
                    className={style.stuList}
                    data={filteredList.map(item => ({
                        ...item,
                        status: item.voteStatus
                    }))}
                    renderStatus={renderStatus}
                />
            </div>
        </div>
    );
}
